export type IAdminFireBase = {
  status: string;
  email: string;
  name: string;
  phone: string;
  id: number;
  uid: string;
  photoUrl: string;
};

export type IAdminsWithMeta = {
  admins: IAdmin[];
  total: number;
};

export type IAdmin = {
  email: string[];
  uid: string;
  name: string;
  status: AdminRole;
  emails: { email: string; uid: string }[];
};

export enum AdminRole {
  ADMIN = "Admin",
  SUPER_ADMIN = "Super admin",
}

